import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44e97e58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-white" }
const _hoisted_2 = { class: "bg-black-body mt-20" }
const _hoisted_3 = { class: "mx-12 lg:mx-28 flex flex-col md:flex-row md:space-x-10" }
const _hoisted_4 = { class: "flex flex-col md:w-1/3 xl:w-1/4 bg-gray-700 -mt-10 h-max rounded-md mb-5" }
const _hoisted_5 = { class: "flex flex-col items-center space-y-3 py-8 border-b-2 border-black-border" }
const _hoisted_6 = { class: "inline-block relative border-2 border-gray-text rounded-full bottom-0 w-28 h-28 left-0 p-0.5" }
const _hoisted_7 = { class: "font-bold text-lg" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "items-center hidden" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Set Profile Publicity"),
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    class: "iconify iconify--ic h-4 w-4",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6l-6-6l1.41-1.41z"
    })
  ])
], -1))
const _hoisted_9 = { class: "flex flex-col p-8 border-b-2 border-black-border" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Player's Bio", -1))
const _hoisted_11 = { class: "flex justify-between text-sm mt-5" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-left" }, "Email", -1))
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = { class: "flex justify-between text-sm mt-5" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-left" }, "Date Joined", -1))
const _hoisted_16 = { class: "text-right" }
const _hoisted_17 = { class: "hidden justify-between text-sm mt-5" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-left" }, "Date Verified", -1))
const _hoisted_19 = { class: "text-right" }
const _hoisted_20 = { class: "flex justify-between text-sm mt-3 items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-left" }, "Country", -1))
const _hoisted_22 = { class: "flex items-center" }
const _hoisted_23 = { class: "text-right mr-2" }
const _hoisted_24 = { class: "justify-between text-sm mt-3 hidden" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-left" }, "MetaXar Rank", -1))
const _hoisted_26 = { class: "text-right bg-black-body px-2 border-2 border-gray-text" }
const _hoisted_27 = { class: "flex-col p-8 border-b-2 border-black-border hidden" }
const _hoisted_28 = { class: "flex flex-col justify-between text-sm mt-5" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-left" }, "Current Tournament", -1))
const _hoisted_30 = { class: "" }
const _hoisted_31 = { class: "flex justify-between text-sm mt-5" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-left" }, "Games Played", -1))
const _hoisted_33 = { class: "text-right" }
const _hoisted_34 = { class: "flex justify-between text-sm mt-5" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-left" }, "Play Time", -1))
const _hoisted_36 = { class: "text-right" }
const _hoisted_37 = {
  key: 0,
  class: "flex-col p-8 border-b-2 border-black-border"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Social Media", -1))
const _hoisted_39 = { class: "flex space-x-4 text-sm mt-5" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M16.36 14c.08-.66.14-1.32.14-2c0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2m-5.15 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 0 1-4.33 3.56M14.34 14H9.66c-.1-.66-.16-1.32-.16-2c0-.68.06-1.35.16-2h4.68c.09.65.16 1.32.16 2c0 .68-.07 1.34-.16 2M12 19.96c-.83-1.2-1.5-2.53-1.91-3.96h3.82c-.41 1.43-1.08 2.76-1.91 3.96M8 8H5.08A7.923 7.923 0 0 1 9.4 4.44C8.8 5.55 8.35 6.75 8 8m-2.92 8H8c.35 1.25.8 2.45 1.4 3.56A8.008 8.008 0 0 1 5.08 16m-.82-2C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2c0 .68.06 1.34.14 2M12 4.03c.83 1.2 1.5 2.54 1.91 3.97h-3.82c.41-1.43 1.08-2.77 1.91-3.97M18.92 8h-2.95a15.65 15.65 0 0 0-1.38-3.56c1.84.63 3.37 1.9 4.33 3.56M12 2C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"
  })
], -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  class: "iconify iconify--mdi h-6 w-6",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "m22 24l-5.25-5l.63 2H4.5A2.5 2.5 0 0 1 2 18.5v-15A2.5 2.5 0 0 1 4.5 1h15A2.5 2.5 0 0 1 22 3.5V24M12 6.8c-2.68 0-4.56 1.15-4.56 1.15c1.03-.92 2.83-1.45 2.83-1.45l-.17-.17c-1.69.03-3.22 1.2-3.22 1.2c-1.72 3.59-1.61 6.69-1.61 6.69c1.4 1.81 3.48 1.68 3.48 1.68l.71-.9c-1.25-.27-2.04-1.38-2.04-1.38S9.3 14.9 12 14.9s4.58-1.28 4.58-1.28s-.79 1.11-2.04 1.38l.71.9s2.08.13 3.48-1.68c0 0 .11-3.1-1.61-6.69c0 0-1.53-1.17-3.22-1.2l-.17.17s1.8.53 2.83 1.45c0 0-1.88-1.15-4.56-1.15m-2.07 3.79c.65 0 1.18.57 1.17 1.27c0 .69-.52 1.27-1.17 1.27c-.64 0-1.16-.58-1.16-1.27c0-.7.51-1.27 1.16-1.27m4.17 0c.65 0 1.17.57 1.17 1.27c0 .69-.52 1.27-1.17 1.27c-.64 0-1.16-.58-1.16-1.27c0-.7.51-1.27 1.16-1.27Z"
  })
], -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  class: "iconify iconify--mdi h-6 w-6",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M22.46 6c-.77.35-1.6.58-2.46.69c.88-.53 1.56-1.37 1.88-2.38c-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29c0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15c0 1.49.75 2.81 1.91 3.56c-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07a4.28 4.28 0 0 0 4 2.98a8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21C16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56c.84-.6 1.56-1.36 2.14-2.23Z"
  })
], -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "mt-16 md:w-2/3 xl:w-4/5" }
const _hoisted_47 = { class: "pb-4 border-b-2 border-gray-700" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-md" }, "Favourite Games", -1))
const _hoisted_49 = {
  key: 0,
  class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 py-6"
}
const _hoisted_50 = { class: "flex flex-col space-y-4 card-cover" }
const _hoisted_51 = { class: "group relative transform hover:-translate-y-2 transition-all duration-200 w-full" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rounded-2xl absolute opacity-0 top-0 left-0 h-full justify-center items-center flex w-full bg-red-hover bg-opacity-30 group-hover:opacity-100" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    class: "iconify iconify--material-symbols fill-white",
    width: "60",
    height: "60",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "m9.5 16.5l7-4.5l-7-4.5ZM12 22q-2.075 0-3.9-.788q-1.825-.787-3.175-2.137q-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175q1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138q1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175q-1.35 1.35-3.175 2.137Q14.075 22 12 22Zm0-2q3.35 0 5.675-2.325Q20 15.35 20 12q0-3.35-2.325-5.675Q15.35 4 12 4Q8.65 4 6.325 6.325Q4 8.65 4 12q0 3.35 2.325 5.675Q8.65 20 12 20Zm0-8Z"
    })
  ])
], -1))
const _hoisted_53 = { class: "flex flex-col" }
const _hoisted_54 = { class: "text-md md:text-xl truncate font-bold" }
const _hoisted_55 = {
  key: 0,
  class: "text-gray-text truncate h-5 display-block"
}
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = {
  key: 1,
  class: "text-sm mt-3"
}
const _hoisted_58 = /*#__PURE__*/_createTextVNode("See All Favourites")
const _hoisted_59 = { class: "py-14" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-md" }, "Invited Games", -1))
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 py-6" }
const _hoisted_63 = {
  key: 0,
  class: "flex flex-col space-y-4 card-cover"
}
const _hoisted_64 = { class: "group relative transform hover:-translate-y-2 transition-all duration-200" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rounded-2xl absolute opacity-0 top-0 left-0 h-full justify-center items-center flex w-full bg-red-hover bg-opacity-30 group-hover:opacity-100" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    class: "iconify iconify--material-symbols fill-white",
    width: "60",
    height: "60",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "m9.5 16.5l7-4.5l-7-4.5ZM12 22q-2.075 0-3.9-.788q-1.825-.787-3.175-2.137q-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175q1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138q1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175q-1.35 1.35-3.175 2.137Q14.075 22 12 22Zm0-2q3.35 0 5.675-2.325Q20 15.35 20 12q0-3.35-2.325-5.675Q15.35 4 12 4Q8.65 4 6.325 6.325Q4 8.65 4 12q0 3.35 2.325 5.675Q8.65 20 12 20Zm0-8Z"
    })
  ])
], -1))
const _hoisted_66 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_67 = { class: "text-md md:text-xl truncate font-bold" }
const _hoisted_68 = {
  key: 0,
  class: "text-gray-text truncate h-5 display-block"
}
const _hoisted_69 = ["innerHTML"]
const _hoisted_70 = {
  key: 1,
  class: "text-sm mt-3"
}
const _hoisted_71 = {
  key: 2,
  class: "navigation_div"
}
const _hoisted_72 = { class: "navigation-num" }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" Show ")
const _hoisted_74 = /*#__PURE__*/_createStaticVNode("<option value=\"10\" data-v-44e97e58>10</option><option value=\"20\" data-v-44e97e58>20</option><option value=\"30\" data-v-44e97e58>30</option><option value=\"40\" data-v-44e97e58>40</option><option value=\"50\" data-v-44e97e58>50</option>", 5)
const _hoisted_79 = [
  _hoisted_74
]
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" Records ")
const _hoisted_81 = { class: "navigation-menu" }
const _hoisted_82 = {
  key: 2,
  class: "option-disabled"
}
const _hoisted_83 = { class: "navigation-text" }
const _hoisted_84 = {
  key: 4,
  class: "option-disabled"
}
const _hoisted_85 = {
  key: 6,
  class: "option-disabled"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_flag = _resolveComponent("country-flag")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", null, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "bg-cover bg-center bg-black-body w-full h-full rounded-full",
                  style: _normalizeStyle({ 'background-image': `url(${_ctx.image})` })
                }, null, 4)
              ]),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.gamerName), 1),
              _createElementVNode("span", null, "User ID: " + _toDisplayString(_ctx.gamerTag), 1),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.userEmail), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.dateJoined), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.dateVerified), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.countryUser), 1),
                  _createVNode(_component_country_flag, {
                    class: "flex my-auto rounded-full w-10 h-10",
                    country: _ctx.countryCode
                  }, null, 8, ["country"])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.rank), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.tournament), 1)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.gamesPlayed), 1)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.playTime), 1)
              ])
            ]),
            (_ctx.websiteUrl || _ctx.discord || _ctx.twitter)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("div", _hoisted_39, [
                    (_ctx.websiteUrl)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "inline-block cursor-pointer",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openExternalWebsite('https://' + _ctx.websiteUrl)))
                        }, _hoisted_41))
                      : _createCommentVNode("", true),
                    (_ctx.discord)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "inline-block cursor-pointer",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openExternalWebsite('https://discord.com/users/' + _ctx.discord)))
                        }, _hoisted_43))
                      : _createCommentVNode("", true),
                    (_ctx.twitter)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: "inline-block cursor-pointer",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openExternalWebsite('https://twitter.com/' + _ctx.twitter)))
                        }, _hoisted_45))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              (_ctx.displayGames.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayGames.slice(0, 5), (game, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", _hoisted_50, [
                          (game.game.gameId)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: { name: 'viewGamesProfile', params: { gameId: game.game.gameId } }
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_51, [
                                    (game.details.gallery.headerImage)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "card-img-top rounded-2xl w-full",
                                          style: _normalizeStyle('background: url(' + _ctx.assetURL + 'blob/games/' + game.game.gameId + '/gallery/' + game.details.gallery.headerImage + ') #000; background-repeat: no-repeat; background-size: cover; background-position: center')
                                        }, null, 4))
                                      : (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "card-img-top rounded-2xl",
                                          style: _normalizeStyle('background: url(' + require(`@/assets/images/default-cover-small.png`) + '); background-repeat: no-repeat; background-size: cover;')
                                        }, null, 4)),
                                    _hoisted_52
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("span", _hoisted_54, _toDisplayString(game.game.title), 1),
                            (game.details.about.about == null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_55))
                              : (_openBlock(), _createElementBlock("small", {
                                  key: 1,
                                  class: "text-gray-text truncate",
                                  innerHTML: game.details.about.about.replace(/<\/?[^>]+>/ig, '').substring(0, 100)
                                }, null, 8, _hoisted_56))
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_57, " You have no Favourite's game. ")),
              (_ctx.displayGames.length > 5)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    to: { name: 'viewGamerFavourites', params: { gamerId: _ctx.userObj.username } },
                    class: "text-red-primary hover:text-red-hover underline justify-end flex"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_58
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_59, [
              _hoisted_60,
              (_ctx.displayInvitedGames.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayInvitedGames, (game, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          (game.gameDto)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                (game.gameDto.gameId)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: { name: 'viewGamesProfile', params: { gameId: game.gameDto.gameId } }
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_64, [
                                          (game.gameDetailsDto.gallery.headerImage)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "card-img-top rounded-2xl w-full",
                                                style: _normalizeStyle('background: url(' + _ctx.assetURL + 'blob/games/' + game.gameDto.gameId + '/gallery/' + game.gameDetailsDto.gallery.headerImage + ') #000; background-repeat: no-repeat; background-size: cover; background-position: center')
                                              }, null, 4))
                                            : (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: "card-img-top rounded-2xl",
                                                style: _normalizeStyle('background: url(' + require(`@/assets/images/default-cover-small.png`) + '); background-repeat: no-repeat; background-size: cover;')
                                              }, null, 4)),
                                          _hoisted_65
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : _createCommentVNode("", true),
                                (game.gameDto)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                      _createElementVNode("span", _hoisted_67, _toDisplayString(game.gameDto.title), 1),
                                      (game.gameDetailsDto.about.about == null)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_68))
                                        : (_openBlock(), _createElementBlock("small", {
                                            key: 1,
                                            class: "text-gray-text truncate",
                                            innerHTML: game.gameDetailsDto.about.about.replace(/<\/?[^>]+>/ig, '').substring(0, 100)
                                          }, null, 8, _hoisted_69))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_70, "You have no Invited games.")),
              (_ctx.invitedGames.length > 10)
                ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _hoisted_73,
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pages) = $event)),
                        class: "",
                        onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeRows && _ctx.changeRows(...args)))
                      }, _hoisted_79, 544), [
                        [_vModelSelect, _ctx.pages]
                      ]),
                      _hoisted_80
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      (_ctx.enableFirstPage)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.naviFirst && _ctx.naviFirst(...args))),
                            class: "option"
                          }, "First"))
                        : _createCommentVNode("", true),
                      (_ctx.enablePreviousPage)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.naviPrevious && _ctx.naviPrevious(...args))),
                            class: "option"
                          }, " Previous "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_82, "Previous")),
                      _createElementVNode("div", _hoisted_83, " Page " + _toDisplayString(_ctx.currentPage) + " of " + _toDisplayString(_ctx.totalPages), 1),
                      (_ctx.enableNextPage)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 3,
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.naviNext && _ctx.naviNext(...args))),
                            class: "option"
                          }, "Next"))
                        : (_openBlock(), _createElementBlock("div", _hoisted_84, "Next")),
                      (_ctx.enableLastPage)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 5,
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.naviLast && _ctx.naviLast(...args))),
                            class: "option"
                          }, "Last"))
                        : (_openBlock(), _createElementBlock("div", _hoisted_85, "Last"))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}